import { Broadcast } from "./broadcast";
import { EventBus } from "./eventbus";
/** 设置Panda全局配置 */
export function setConfig(params) {
  if (params && params.cookieKey) {
    window.__PANDA.cookieKey = params.cookieKey;
  }
  if (params && typeof params.logLevel !== 'undefined') {
    window.__PANDA.logLevel = params.logLevel;
  }
  if (params && params.langList) {
    window.__PANDA.langList = params.langList;
  }
}

// 兼容处理
export var pandaEvent = typeof BroadcastChannel === 'function' ? new Broadcast() : new EventBus();